import * as cryptoJS from 'crypto-js'

// 用于登录
const DES_DEFAULT_KEY = 'xbbDingtalk!@'

/**
 * @description: DES 加密
 * @param {String} str 待加密字符串
 * @param {String} key
 * @return {String} 加密后的字符串
 */
const desEncrypt = (str, key) => {
  const keyHex = cryptoJS.enc.Utf8.parse(key)
  const encryptedObj = cryptoJS.DES.encrypt(str, keyHex, {
    mode: cryptoJS.mode.ECB,
    padding: cryptoJS.pad.Pkcs7
  })
  return encryptedObj.toString()
}

export { desEncrypt, DES_DEFAULT_KEY }
